import "./footer.css";
const Footer=()=>{
	return(
		<div className="footer">
			<div className="footer_grid">
				<h1>聯絡我們</h1>
			</div>
			<div className="footer_grid">
				<h3>聖亞哥商旅</h3>
				<p>
					地址 : 高雄市前金區明星街155號
					<br />
					LINE: sinyago
					<br />
					FB : 聖亞哥旅館
					<br />
					訂房專線 : 07-2862933
				</p>
			</div>
		</div>
		);
}
export default Footer;